import React, {useState} from 'react'
import {QueryRequestProvider} from '../../appointment/users-list/core/QueryRequestProvider'
import {QueryResponseProvider} from '../../appointment/users-list/core/QueryResponseProvider'
import {ListViewProvider} from '../../appointment/users-list/core/ListViewProvider'
import {PatientTabs} from '../Page'
import {KTCard} from '../../../../../_metronic/helpers'
import {UsersTable} from './table/UsersTable'
import {UsersListHeader} from './components/header/UsersListHeader'

const UsersList = () => {
  const [s, setS] = useState('')
  const [params, setParams] = useState({})
  const [count, setCount] = useState<Array<number>>([])

  return (
    <div>
      <PatientTabs count={count} />
      <KTCard>
        <UsersListHeader
          onFilter={(_params)=>setParams(_params)}
          onSearch={(_s)=>{
            setS(_s)
          }} />
        <UsersTable s={s} params={params} />
      </KTCard>
    </div>
  )
}

const PartialWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <UsersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { PartialWrapper }
